export const translatesReplacements = [
    {
        text: 'tapTheXButton',
        replace: [
            {
                original: '[start]',
                new: 'START'
            }
        ]
    },
    {
        text: 'activateScubscription',
        replace: [
            {
                original: '[percent]',
                new: '25%'
            },
            {
                original: '[tp]',
                new: '[TP_ICON]'
            }
        ]
    },
    {
        text: 'pressKey',
        replace: [
            {
                original: '[key]',
                new: '[KEY]'
            }
        ]
    },
    {
        text: 'tapToButton',
        replace: [
            {
                original: '[button]',
                new: '[BUTTON]'
            }
        ]
    },
    {
        text: 'event_badges-second-third',
        replace: [
            {
                original: '[rank]',
                new: '[rank]'
            }
        ]
    }
];
//# sourceMappingURL=index.js.map